import { Skeleton } from '@mui/material'

import { DOWNLOAD_API } from '@/api'
import { DownloadLink, FullWidthBar, onDownloadLinkClick } from '@/components/core-v2'
import { CURRENCY } from '@/const'
import {
  useFilteredGetByTenantAccountDashboardQuery,
  useNoteFilters
} from '@/modules/reporting/utils/useFilteredNotes'
import { formatCurrencyFull } from '@/utilities/currency'
import { plural } from '@/utilities/plural'

import classes from './index.module.scss'

export const NotesFoundBar = () => {
  const { data, isFetching, isLoading } = useFilteredGetByTenantAccountDashboardQuery()
  const { clientType, currencyCode, noteIds = '' } = useNoteFilters()

  if (isLoading || isFetching) {
    return (
      <FullWidthBar className={classes.root} showBottomBorder={false} size="large">
        <Skeleton data-testid="skeleton" height="16px" variant="rectangular" width="400px" />
      </FullWidthBar>
    )
  }

  const { notes, numberOfActiveAccounts, zarValue } = data
  const showTotalValue = typeof zarValue === 'number'

  const onDownloadClick = () => {
    onDownloadLinkClick({
      url: DOWNLOAD_API.exportAccounts,
      method: 'POST',
      body: {
        ids: noteIds && noteIds.slice(1).split(','),
        currencyCode,
        clientType
      }
    })
  }

  return (
    <FullWidthBar className={classes.root} showBottomBorder={false} size="large">
      <span className={classes.showing}>
        Showing <strong>{notes.length}</strong> {plural('note', notes.length)} with{' '}
        <strong>{numberOfActiveAccounts}</strong> {plural('trade', numberOfActiveAccounts)}
      </span>
      {showTotalValue && (
        <span className={classes.total}>
          <strong>{formatCurrencyFull(zarValue, CURRENCY)}</strong> total value
        </span>
      )}
      <DownloadLink onClick={onDownloadClick}>Export accounts</DownloadLink>
    </FullWidthBar>
  )
}
